import { TYPE_CONTENU } from "../utils/enums";
import { Contenu } from "@/types/contenu";
import { TypeEntite } from "@/types/enum";

export const PUB_EVERY_X = {
    CARTES_MOBILE: 4,
    CARTES_DESKTOP: 8,
    CATEGORIES_MOBILE: 4,
    CATEGORIES_DESKTOP: 2,
    EMISSIONS_LISTE_ALL: 8,
    EMISSION_LISTE_EPISODES: 4,
}

export const PUB_START_INDEX = {
    CARTES: 1,
}

export const INFOLETTRE_INDEXES = {
    EMISSIONS: [8],
};

// Recettes and Articles IDs to render Tuile Native pub
export const TUILE_VIDEO_IDS = {
    RECETTES: [5594, 6188, 6192, 6582, 6583],
    ARTICLES: [251],
};

const getPubObj = (index: number) => ({
    id: `pub-${index}`,
    titre: "publicité",
    type: TYPE_CONTENU.PUBLICITE as TypeEntite.Source,
});

/**
 * Insère un objet pub/publicité dans une liste à intervalles réguliers.
 * 
 * @param list - La liste original d'éléments Contenu dans lequel insérer les pubs
 * @param n - L'intervalle auquel insérer les pubs (à chaque nième position)
 * @returns Une nouvelle liste avec des objets pub insérés aux intervalles spécifiés
 * 
 * @example
 * // Insère une pub tous les 2 éléments
 * const contentList = [item1, item2, item3, item4];
 * const withPubs = withPubEveryX(contentList, 2);
 * // Résultat: [item1, item2, pub, item3, item4]
 * // Insère une pub tous les 3 éléments, en commençant par le deuxieme élément
 * const withPubs = withPubEveryX(contentList, 3, 1);
 * // Résultat: [item1, pub, item2, item3, item4, pub]
 */
export const withPubEveryX = (list: Contenu[], n: number, first = n) => {
    const newList = [...list];
    if (n > 0 && first >= 0) {
        for (let i = first; i < newList.length; i += n + 1) {
            newList.splice(i, 0, getPubObj(i));
        }
    }
    return newList;
};
